import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isPlatform } from '@ionic/react';

const isNative = () => !isPlatform('mobileweb') && !isPlatform('desktop');

export const hapticsImpactMedium = async () => {
    if (isNative()) {
        await Haptics.impact({ style: ImpactStyle.Medium });
    }
};

export const hapticsImpactLight = async () => {
    if (isNative()) {
        await Haptics.impact({ style: ImpactStyle.Light });
    }
};

// Best-effort tap feedback for buttons/links that fire on every device.
// Native: Capacitor Haptics light impact. Mobile web: navigator.vibrate
// (Android Chrome only; iOS Safari ignores the call). Safe to call from
// any platform — both branches no-op silently when not supported.
export const tapFeedback = () => {
    void hapticsImpactLight();
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
        try { navigator.vibrate(8); } catch (_) {}
    }
};

// Soft selection blip — used for tab switches, chip taps, carousel page
// changes. iOS Taptic Engine renders this as a tiny "click"; Android maps
// it to a short vibration via Capacitor; web no-ops.
export const hapticsSelection = async () => {
    if (isNative()) {
        await Haptics.selectionChanged();
    }
};

// Warning-class confirmation — for destructive double-tap or threshold
// confirmations. Used sparingly.
export const hapticsNotificationWarning = async () => {
    if (isNative()) {
        await Haptics.notification({ type: NotificationType.Warning });
    }
};

// Success-class confirmation — fired when a state transition is the
// "good" outcome (Mark ready flip, payment confirmed, etc.). The
// success notification is more affirmative than a plain impact and is
// the right fit for "you finished a step" moments.
export const hapticsNotificationSuccess = async () => {
    if (isNative()) {
        await Haptics.notification({ type: NotificationType.Success });
    }
};

